import styled from "@emotion/styled";
import React from "react";
import SectionTitle from "../../common/SectionTitle";

export default function ShopInfoList() {
    return (
        <Container>
            <ShopInfoListContent>
                <div className="showroom">
                    <div className="bl_shop">
                        <h3 className="shop_name">KNITLOGY ショールーム</h3>
                        <p className="address">
                            〒326-0814<br />
                            栃木県足利市通3丁目2763<br />
                        </p>
                        <p className="supplement">
                            ※不定期オープン
                        </p>
                    </div>
                </div>

                <div className="bl_shop_list">
                    <div className="bl_shop">
                        <h3 className="shop_name">IDÉE TOKYO</h3>
                        <p className="address">
                            〒100-0005<br/>
                            東京都千代田区丸の内１丁目９−１<br/>
                            ＪＲ東京駅構内グランスタB1F<br />
                            03-5224-8861
                        </p>
                    </div>

                    <div className="bl_shop">
                        <h3 className="shop_name">Délier IDÉE (丸の内)</h3>
                        <p className="address">
                            〒100-6504<br/>
                            東京都千代田区丸の内1-5-1<br/>
                            新丸ビル4F
                        </p>
                    </div>

                    <div className="bl_shop">
                        <h3 className="shop_name">takase</h3>
                        <p className="address">
                            〒336-0916<br/>
                            埼玉県さいたま市緑区宮本2-19-14
                        </p>
                    </div>

                    <div className="bl_shop">
                        <h3 className="shop_name">gallery yamahon</h3>
                        <p className="address">
                            〒518-1325<br/>
                            三重県伊賀市丸柱1650
                        </p>
                    </div>

                    <div className="bl_shop">
                        <h3 className="shop_name">ギャルリ灰月</h3>
                        <p className="address">
                            〒390-0811<br/>
                            長野県松本市中央2-2-6<br/>
                            高美書店2
                        </p>
                    </div>

                    <div className="bl_shop">
                        <h3 className="shop_name">olga</h3>
                        <p className="address">
                            〒659-0068<br/>
                            兵庫県芦屋市業平町5-16<br/>
                            航洋ビル1階西側
                        </p>
                    </div>

                    <div className="bl_shop">
                        <h3 className="shop_name">+106</h3>
                        <p className="address">
                            〒761-0113<br/>
                            香川県高松市屋島西町2453-20<br/>
                            RENOWA YASHIMA 106号室
                        </p>
                    </div>

                </div>

            </ShopInfoListContent>
        </Container>
    );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  color: white;
`;

const ShopInfoListContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-evenly;
  
  .showroom{
    width: 100%;
    margin-top: 30px;
  }
  
  .bl_shop_list{
    margin-top:40px;

    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 24px;
  }

  .bl_shop {
    min-height: 140px;
  }

  .shop_name {
    //font-family: YuMincho;
    font-weight: bold;
    font-size: 13px;
    letter-spacing: 0.1em;
    line-height: 28px;
    text-align: center;
    color: #C7C7C7;
  }

  .address {
    //font-family: YuMincho;
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.1em;
    line-height: 23px;
    text-align: center;
    color: #aba7a3;
  }

  .supplement {
    //font-family: YuMincho;
    font-weight: 500;
    font-size: 11px;
    letter-spacing: 0.1em;
    line-height: 23px;
    text-align: center;
    color: #aba7a3;
  }

  p {
    font-size: 13px;
    margin: 0;
  }
`;